import type { ComponentType } from "react";
import { Route, type RouteProps } from "wouter";
import { AppShell } from "../layout/AppShell";
import { RequireAuth } from "./RequireAuth";

type ProtectedRouteProps = Omit<RouteProps, "component" | "children"> & {
  component: ComponentType;
};

/**
 * A Route whose page is sign-in only, shown inside the app shell (sidebar and all). Works inside a Switch: the rest of the props
 * (including the `match` that Switch adds) go straight to Route, so `useParams` still works.
 */
export function ProtectedRoute({ component: Page, ...props }: ProtectedRouteProps) {
  return (
    <Route {...props}>
      <RequireAuth>
        <AppShell>
          <Page />
        </AppShell>
      </RequireAuth>
    </Route>
  );
}
